export const CryptoJS_Secret_Key = "fhfj3kJHGFG4khkh*#767!#@WEf";

export const SignUp_Content = {
  REGISTRATION: "Registration",
};

export const indianStates = [
  { id: 'Andaman and Nicobar Islands', label: 'Andaman and Nicobar Islands' },
  { id: 'Andhra Pradesh', label: 'Andhra Pradesh' },
  { id: 'Arunachal Pradesh', label: 'Arunachal Pradesh' },
  { id: 'Assam', label: 'Assam' },
  { id: 'Bihar', label: 'Bihar' },
  { id: 'Chandigarh', label: 'Chandigarh' },
  { id: 'Chhattisgarh', label: 'Chhattisgarh' },
  {
    id: 'Dadra and Nagar Haveli and Daman and Diu',
    label: 'Dadra and Nagar Haveli and Daman and Diu',
  },
  { id: 'Delhi', label: 'Delhi' },
  { id: 'Goa', label: 'Goa' },
  { id: 'Gujarat', label: 'Gujarat' },
  { id: 'Haryana', label: 'Haryana' },
  { id: 'Himachal Pradesh', label: 'Himachal Pradesh' },
  { id: 'Jharkhand', label: 'Jharkhand' },
  { id: 'Karnataka', label: 'Karnataka' },
  { id: 'Kerala', label: 'Kerala' },
  { id: 'Lakshadweep', label: 'Lakshadweep' },
  { id: 'Madhya Pradesh', label: 'Madhya Pradesh' },
  { id: 'Maharashtra', label: 'Maharashtra' },
  { id: 'Manipur', label: 'Manipur' },
  { id: 'Meghalaya', label: 'Meghalaya' },
  { id: 'Mizoram', label: 'Mizoram' },
  { id: 'Nagaland', label: 'Nagaland' },
  { id: 'Odisha', label: 'Odisha' },
  { id: 'Puducherry', label: 'Puducherry' },
  { id: 'Punjab', label: 'Punjab' },
  { id: 'Rajasthan', label: 'Rajasthan' },
  { id: 'Sikkim', label: 'Sikkim' },
  { id: 'Tamil Nadu', label: 'Tamil Nadu' },
  { id: 'Telangana', label: 'Telangana' },
  { id: 'Tripura', label: 'Tripura' },
  { id: 'Uttar Pradesh', label: 'Uttar Pradesh' },
  { id: 'Uttarakhand', label: 'Uttarakhand' },
  { id: 'West Bengal', label: 'West Bengal' },
];

export const stateWiseCities = {
  'Andaman and Nicobar Islands': [{ id: 'Port Blair', label: 'Port Blair' }],
  Haryana: [
    { id: 'Faridabad', label: 'Faridabad' },
    { id: 'Gurgaon', label: 'Gurgaon' },
    { id: 'Hisar', label: 'Hisar' },
    { id: 'Rohtak', label: 'Rohtak' },
    { id: 'Panipat', label: 'Panipat' },
    { id: 'Karnal', label: 'Karnal' },
    { id: 'Sonipat', label: 'Sonipat' },
    { id: 'Yamunanagar', label: 'Yamunanagar' },
    { id: 'Panchkula', label: 'Panchkula' },
    { id: 'Bhiwani', label: 'Bhiwani' },
    { id: 'Bahadurgarh', label: 'Bahadurgarh' },
    { id: 'Jind', label: 'Jind' },
    { id: 'Sirsa', label: 'Sirsa' },
    { id: 'Thanesar', label: 'Thanesar' },
    { id: 'Kaithal', label: 'Kaithal' },
    { id: 'Palwal', label: 'Palwal' },
    { id: 'Rewari', label: 'Rewari' },
    { id: 'Hansi', label: 'Hansi' },
    { id: 'Narnaul', label: 'Narnaul' },
    { id: 'Fatehabad', label: 'Fatehabad' },
    { id: 'Gohana', label: 'Gohana' },
    { id: 'Tohana', label: 'Tohana' },
    { id: 'Narwana', label: 'Narwana' },
    { id: 'Mandi Dabwali', label: 'Mandi Dabwali' },
    { id: 'Charkhi Dadri', label: 'Charkhi Dadri' },
    { id: 'Shahbad', label: 'Shahbad' },
    { id: 'Pehowa', label: 'Pehowa' },
    { id: 'Samalkha', label: 'Samalkha' },
    { id: 'Pinjore', label: 'Pinjore' },
    { id: 'Ladwa', label: 'Ladwa' },
    { id: 'Sohna', label: 'Sohna' },
    { id: 'Safidon', label: 'Safidon' },
    { id: 'Taraori', label: 'Taraori' },
    { id: 'Mahendragarh', label: 'Mahendragarh' },
    { id: 'Ratia', label: 'Ratia' },
    { id: 'Rania', label: 'Rania' },
    { id: 'Sarsod', label: 'Sarsod' },
  ],
  'Tamil Nadu': [
    { id: 'Chennai', label: 'Chennai' },
    { id: 'Coimbatore', label: 'Coimbatore' },
    { id: 'Madurai', label: 'Madurai' },
    { id: 'Tiruchirappalli', label: 'Tiruchirappalli' },
    { id: 'Salem', label: 'Salem' },
    { id: 'Tirunelveli', label: 'Tirunelveli' },
    { id: 'Tiruppur', label: 'Tiruppur' },
    { id: 'Ranipet', label: 'Ranipet' },
    { id: 'Nagercoil', label: 'Nagercoil' },
    { id: 'Thanjavur', label: 'Thanjavur' },
    { id: 'Vellore', label: 'Vellore' },
    { id: 'Kancheepuram', label: 'Kancheepuram' },
    { id: 'Erode', label: 'Erode' },
    { id: 'Tiruvannamalai', label: 'Tiruvannamalai' },
    { id: 'Pollachi', label: 'Pollachi' },
    { id: 'Rajapalayam', label: 'Rajapalayam' },
    { id: 'Sivakasi', label: 'Sivakasi' },
    { id: 'Pudukkottai', label: 'Pudukkottai' },
    { id: 'Neyveli (TS)', label: 'Neyveli (TS)' },
    { id: 'Nagapattinam', label: 'Nagapattinam' },
    { id: 'Viluppuram', label: 'Viluppuram' },
    { id: 'Tiruchengode', label: 'Tiruchengode' },
    { id: 'Vaniyambadi', label: 'Vaniyambadi' },
    { id: 'Theni Allinagaram', label: 'Theni Allinagaram' },
    { id: 'Udhagamandalam', label: 'Udhagamandalam' },
    { id: 'Aruppukkottai', label: 'Aruppukkottai' },
    { id: 'Paramakudi', label: 'Paramakudi' },
    { id: 'Arakkonam', label: 'Arakkonam' },
    { id: 'Virudhachalam', label: 'Virudhachalam' },
    { id: 'Srivilliputhur', label: 'Srivilliputhur' },
    { id: 'Tindivanam', label: 'Tindivanam' },
    { id: 'Virudhunagar', label: 'Virudhunagar' },
    { id: 'Karur', label: 'Karur' },
    { id: 'Valparai', label: 'Valparai' },
    { id: 'Sankarankovil', label: 'Sankarankovil' },
    { id: 'Tenkasi', label: 'Tenkasi' },
    { id: 'Palani', label: 'Palani' },
    { id: 'Pattukkottai', label: 'Pattukkottai' },
    { id: 'Tirupathur', label: 'Tirupathur' },
    { id: 'Ramanathapuram', label: 'Ramanathapuram' },
    { id: 'Udumalaipettai', label: 'Udumalaipettai' },
    { id: 'Gobichettipalayam', label: 'Gobichettipalayam' },
    { id: 'Thiruvarur', label: 'Thiruvarur' },
    { id: 'Thiruvallur', label: 'Thiruvallur' },
    { id: 'Panruti', label: 'Panruti' },
    { id: 'Namakkal', label: 'Namakkal' },
    { id: 'Thirumangalam', label: 'Thirumangalam' },
    { id: 'Vikramasingapuram', label: 'Vikramasingapuram' },
    { id: 'Nellikuppam', label: 'Nellikuppam' },
    { id: 'Rasipuram', label: 'Rasipuram' },
    { id: 'Tiruttani', label: 'Tiruttani' },
    { id: 'Nandivaram-Guduvancheri', label: 'Nandivaram-Guduvancheri' },
    { id: 'Periyakulam', label: 'Periyakulam' },
    { id: 'Pernampattu', label: 'Pernampattu' },
    { id: 'Vellakoil', label: 'Vellakoil' },
    { id: 'Sivaganga', label: 'Sivaganga' },
    { id: 'Vadalur', label: 'Vadalur' },
    { id: 'Rameshwaram', label: 'Rameshwaram' },
    { id: 'Tiruvethipuram', label: 'Tiruvethipuram' },
    { id: 'Perambalur', label: 'Perambalur' },
    { id: 'Usilampatti', label: 'Usilampatti' },
    { id: 'Vedaranyam', label: 'Vedaranyam' },
    { id: 'Sathyamangalam', label: 'Sathyamangalam' },
    { id: 'Puliyankudi', label: 'Puliyankudi' },
    { id: 'Nanjikottai', label: 'Nanjikottai' },
    { id: 'Thuraiyur', label: 'Thuraiyur' },
    { id: 'Sirkali', label: 'Sirkali' },
    { id: 'Tiruchendur', label: 'Tiruchendur' },
    { id: 'Periyasemur', label: 'Periyasemur' },
    { id: 'Sattur', label: 'Sattur' },
    { id: 'Vandavasi', label: 'Vandavasi' },
    { id: 'Tharamangalam', label: 'Tharamangalam' },
    { id: 'Tirukkoyilur', label: 'Tirukkoyilur' },
    { id: 'Oddanchatram', label: 'Oddanchatram' },
    { id: 'Palladam', label: 'Palladam' },
    { id: 'Vadakkuvalliyur', label: 'Vadakkuvalliyur' },
    { id: 'Tirukalukundram', label: 'Tirukalukundram' },
    { id: 'Uthamapalayam', label: 'Uthamapalayam' },
    { id: 'Surandai', label: 'Surandai' },
    { id: 'Sankari', label: 'Sankari' },
    { id: 'Shenkottai', label: 'Shenkottai' },
    { id: 'Vadipatti', label: 'Vadipatti' },
    { id: 'Sholingur', label: 'Sholingur' },
    { id: 'Tirupathur', label: 'Tirupathur' },
    { id: 'Manachanallur', label: 'Manachanallur' },
    { id: 'Viswanatham', label: 'Viswanatham' },
    { id: 'Polur', label: 'Polur' },
    { id: 'Panagudi', label: 'Panagudi' },
    { id: 'Uthiramerur', label: 'Uthiramerur' },
    { id: 'Thiruthuraipoondi', label: 'Thiruthuraipoondi' },
    { id: 'Pallapatti', label: 'Pallapatti' },
    { id: 'Ponneri', label: 'Ponneri' },
    { id: 'Lalgudi', label: 'Lalgudi' },
    { id: 'Natham', label: 'Natham' },
    { id: 'Unnamalaikadai', label: 'Unnamalaikadai' },
    { id: 'P.N.Patti', label: 'P.N.Patti' },
    { id: 'Tharangambadi', label: 'Tharangambadi' },
    { id: 'Tittakudi', label: 'Tittakudi' },
    { id: 'Pacode', label: 'Pacode' },
    { id: "O' Valley", label: "O' Valley" },
    { id: 'Suriyampalayam', label: 'Suriyampalayam' },
    { id: 'Sholavandan', label: 'Sholavandan' },
    { id: 'Thammampatti', label: 'Thammampatti' },
    { id: 'Namagiripettai', label: 'Namagiripettai' },
    { id: 'Peravurani', label: 'Peravurani' },
    { id: 'Parangipettai', label: 'Parangipettai' },
    { id: 'Pudupattinam', label: 'Pudupattinam' },
    { id: 'Pallikonda', label: 'Pallikonda' },
    { id: 'Sivagiri', label: 'Sivagiri' },
    { id: 'Punjaipugalur', label: 'Punjaipugalur' },
    { id: 'Padmanabhapuram', label: 'Padmanabhapuram' },
    { id: 'Thirupuvanam', label: 'Thirupuvanam' },
  ],
  'Madhya Pradesh': [
    { id: 'Indore', label: 'Indore' },
    { id: 'Bhopal', label: 'Bhopal' },
    { id: 'Jabalpur', label: 'Jabalpur' },
    { id: 'Gwalior', label: 'Gwalior' },
    { id: 'Ujjain', label: 'Ujjain' },
    { id: 'Sagar', label: 'Sagar' },
    { id: 'Ratlam', label: 'Ratlam' },
    { id: 'Satna', label: 'Satna' },
    { id: 'Murwara (Katni)', label: 'Murwara (Katni)' },
    { id: 'Morena', label: 'Morena' },
    { id: 'Singrauli', label: 'Singrauli' },
    { id: 'Rewa', label: 'Rewa' },
    { id: 'Vidisha', label: 'Vidisha' },
    { id: 'Ganjbasoda', label: 'Ganjbasoda' },
    { id: 'Shivpuri', label: 'Shivpuri' },
    { id: 'Mandsaur', label: 'Mandsaur' },
    { id: 'Neemuch', label: 'Neemuch' },
    { id: 'Nagda', label: 'Nagda' },
    { id: 'Itarsi', label: 'Itarsi' },
    { id: 'Sarni', label: 'Sarni' },
    { id: 'Sehore', label: 'Sehore' },
    { id: 'Mhow Cantonment', label: 'Mhow Cantonment' },
    { id: 'Seoni', label: 'Seoni' },
    { id: 'Balaghat', label: 'Balaghat' },
    { id: 'Ashok Nagar', label: 'Ashok Nagar' },
    { id: 'Tikamgarh', label: 'Tikamgarh' },
    { id: 'Shahdol', label: 'Shahdol' },
    { id: 'Pithampur', label: 'Pithampur' },
    { id: 'Alirajpur', label: 'Alirajpur' },
    { id: 'Mandla', label: 'Mandla' },
    { id: 'Sheopur', label: 'Sheopur' },
    { id: 'Shajapur', label: 'Shajapur' },
    { id: 'Panna', label: 'Panna' },
    { id: 'Raghogarh-Vijaypur', label: 'Raghogarh-Vijaypur' },
    { id: 'Sendhwa', label: 'Sendhwa' },
    { id: 'Sidhi', label: 'Sidhi' },
    { id: 'Pipariya', label: 'Pipariya' },
    { id: 'Shujalpur', label: 'Shujalpur' },
    { id: 'Sironj', label: 'Sironj' },
    { id: 'Pandhurna', label: 'Pandhurna' },
    { id: 'Nowgong', label: 'Nowgong' },
    { id: 'Mandideep', label: 'Mandideep' },
    { id: 'Sihora', label: 'Sihora' },
    { id: 'Raisen', label: 'Raisen' },
    { id: 'Lahar', label: 'Lahar' },
    { id: 'Maihar', label: 'Maihar' },
    { id: 'Sanawad', label: 'Sanawad' },
    { id: 'Sabalgarh', label: 'Sabalgarh' },
    { id: 'Umaria', label: 'Umaria' },
    { id: 'Porsa', label: 'Porsa' },
    { id: 'Narsinghgarh', label: 'Narsinghgarh' },
    { id: 'Malaj Khand', label: 'Malaj Khand' },
    { id: 'Sarangpur', label: 'Sarangpur' },
    { id: 'Mundi', label: 'Mundi' },
    { id: 'Nepanagar', label: 'Nepanagar' },
    { id: 'Pasan', label: 'Pasan' },
    { id: 'Mahidpur', label: 'Mahidpur' },
    { id: 'Seoni-Malwa', label: 'Seoni-Malwa' },
    { id: 'Rehli', label: 'Rehli' },
    { id: 'Manawar', label: 'Manawar' },
    { id: 'Rahatgarh', label: 'Rahatgarh' },
    { id: 'Panagar', label: 'Panagar' },
    { id: 'Wara Seoni', label: 'Wara Seoni' },
    { id: 'Tarana', label: 'Tarana' },
    { id: 'Sausar', label: 'Sausar' },
    { id: 'Rajgarh', label: 'Rajgarh' },
    { id: 'Niwari', label: 'Niwari' },
    { id: 'Mauganj', label: 'Mauganj' },
    { id: 'Manasa', label: 'Manasa' },
    { id: 'Nainpur', label: 'Nainpur' },
    { id: 'Prithvipur', label: 'Prithvipur' },
    { id: 'Sohagpur', label: 'Sohagpur' },
    { id: 'Nowrozabad (Khodargama)', label: 'Nowrozabad (Khodargama)' },
    { id: 'Shamgarh', label: 'Shamgarh' },
    { id: 'Maharajpur', label: 'Maharajpur' },
    { id: 'Multai', label: 'Multai' },
    { id: 'Pali', label: 'Pali' },
    { id: 'Pachore', label: 'Pachore' },
    { id: 'Rau', label: 'Rau' },
    { id: 'Mhowgaon', label: 'Mhowgaon' },
    { id: 'Vijaypur', label: 'Vijaypur' },
    { id: 'Narsinghgarh', label: 'Narsinghgarh' },
  ],
  Jharkhand: [
    { id: 'Dhanbad', label: 'Dhanbad' },
    { id: 'Ranchi', label: 'Ranchi' },
    { id: 'Jamshedpur', label: 'Jamshedpur' },
    { id: 'Bokaro Steel City', label: 'Bokaro Steel City' },
    { id: 'Deoghar', label: 'Deoghar' },
    { id: 'Phusro', label: 'Phusro' },
    { id: 'Adityapur', label: 'Adityapur' },
    { id: 'Hazaribag', label: 'Hazaribag' },
    { id: 'Giridih', label: 'Giridih' },
    { id: 'Ramgarh', label: 'Ramgarh' },
    { id: 'Jhumri Tilaiya', label: 'Jhumri Tilaiya' },
    { id: 'Saunda', label: 'Saunda' },
    { id: 'Sahibganj', label: 'Sahibganj' },
    { id: 'Medininagar (Daltonganj)', label: 'Medininagar (Daltonganj)' },
    { id: 'Chaibasa', label: 'Chaibasa' },
    { id: 'Chatra', label: 'Chatra' },
    { id: 'Gumia', label: 'Gumia' },
    { id: 'Dumka', label: 'Dumka' },
    { id: 'Madhupur', label: 'Madhupur' },
    { id: 'Chirkunda', label: 'Chirkunda' },
    { id: 'Pakaur', label: 'Pakaur' },
    { id: 'Simdega', label: 'Simdega' },
    { id: 'Musabani', label: 'Musabani' },
    { id: 'Mihijam', label: 'Mihijam' },
    { id: 'Patratu', label: 'Patratu' },
    { id: 'Lohardaga', label: 'Lohardaga' },
    { id: 'Tenu dam-cum-Kathhara', label: 'Tenu dam-cum-Kathhara' },
  ],
  Mizoram: [
    { id: 'Aizawl', label: 'Aizawl' },
    { id: 'Lunglei', label: 'Lunglei' },
    { id: 'Saiha', label: 'Saiha' },
  ],
  Nagaland: [
    { id: 'Dimapur', label: 'Dimapur' },
    { id: 'Kohima', label: 'Kohima' },
    { id: 'Zunheboto', label: 'Zunheboto' },
    { id: 'Tuensang', label: 'Tuensang' },
    { id: 'Wokha', label: 'Wokha' },
    { id: 'Mokokchung', label: 'Mokokchung' },
  ],
  'Himachal Pradesh': [
    { id: 'Shimla', label: 'Shimla' },
    { id: 'Mandi', label: 'Mandi' },
    { id: 'Solan', label: 'Solan' },
    { id: 'Nahan', label: 'Nahan' },
    { id: 'Sundarnagar', label: 'Sundarnagar' },
    { id: 'Palampur', label: 'Palampur' },
    { id: 'Kullu', label: 'Kullu' },
  ],
  Tripura: [
    { id: 'Agartala', label: 'Agartala' },
    { id: 'Udaipur', label: 'Udaipur' },
    { id: 'Dharmanagar', label: 'Dharmanagar' },
    { id: 'Pratapgarh', label: 'Pratapgarh' },
    { id: 'Kailasahar', label: 'Kailasahar' },
    { id: 'Belonia', label: 'Belonia' },
    { id: 'Khowai', label: 'Khowai' },
  ],
  'Andhra Pradesh': [
    { id: 'Visakhapatnam', label: 'Visakhapatnam' },
    { id: 'Vijayawada', label: 'Vijayawada' },
    { id: 'Guntur', label: 'Guntur' },
    { id: 'Nellore', label: 'Nellore' },
    { id: 'Kurnool', label: 'Kurnool' },
    { id: 'Rajahmundry', label: 'Rajahmundry' },
    { id: 'Kakinada', label: 'Kakinada' },
    { id: 'Tirupati', label: 'Tirupati' },
    { id: 'Anantapur', label: 'Anantapur' },
    { id: 'Kadapa', label: 'Kadapa' },
    { id: 'Vizianagaram', label: 'Vizianagaram' },
    { id: 'Eluru', label: 'Eluru' },
    { id: 'Ongole', label: 'Ongole' },
    { id: 'Nandyal', label: 'Nandyal' },
    { id: 'Machilipatnam', label: 'Machilipatnam' },
    { id: 'Adoni', label: 'Adoni' },
    { id: 'Tenali', label: 'Tenali' },
    { id: 'Chittoor', label: 'Chittoor' },
    { id: 'Hindupur', label: 'Hindupur' },
    { id: 'Proddatur', label: 'Proddatur' },
    { id: 'Bhimavaram', label: 'Bhimavaram' },
    { id: 'Madanapalle', label: 'Madanapalle' },
    { id: 'Guntakal', label: 'Guntakal' },
    { id: 'Dharmavaram', label: 'Dharmavaram' },
    { id: 'Gudivada', label: 'Gudivada' },
    { id: 'Srikakulam', label: 'Srikakulam' },
    { id: 'Narasaraopet', label: 'Narasaraopet' },
    { id: 'Rajampet', label: 'Rajampet' },
    { id: 'Tadpatri', label: 'Tadpatri' },
    { id: 'Tadepalligudem', label: 'Tadepalligudem' },
    { id: 'Chilakaluripet', label: 'Chilakaluripet' },
    { id: 'Yemmiganur', label: 'Yemmiganur' },
    { id: 'Kadiri', label: 'Kadiri' },
    { id: 'Chirala', label: 'Chirala' },
    { id: 'Anakapalle', label: 'Anakapalle' },
    { id: 'Kavali', label: 'Kavali' },
    { id: 'Palacole', label: 'Palacole' },
    { id: 'Sullurpeta', label: 'Sullurpeta' },
    { id: 'Tanuku', label: 'Tanuku' },
    { id: 'Rayachoti', label: 'Rayachoti' },
    { id: 'Srikalahasti', label: 'Srikalahasti' },
    { id: 'Bapatla', label: 'Bapatla' },
    { id: 'Naidupet', label: 'Naidupet' },
    { id: 'Nagari', label: 'Nagari' },
    { id: 'Gudur', label: 'Gudur' },
    { id: 'Vinukonda', label: 'Vinukonda' },
    { id: 'Narasapuram', label: 'Narasapuram' },
    { id: 'Nuzvid', label: 'Nuzvid' },
    { id: 'Markapur', label: 'Markapur' },
    { id: 'Ponnur', label: 'Ponnur' },
    { id: 'Kandukur', label: 'Kandukur' },
    { id: 'Bobbili', label: 'Bobbili' },
    { id: 'Rayadurg', label: 'Rayadurg' },
    { id: 'Samalkot', label: 'Samalkot' },
    { id: 'Jaggaiahpet', label: 'Jaggaiahpet' },
    { id: 'Tuni', label: 'Tuni' },
    { id: 'Amalapuram', label: 'Amalapuram' },
    { id: 'Bheemunipatnam', label: 'Bheemunipatnam' },
    { id: 'Venkatagiri', label: 'Venkatagiri' },
    { id: 'Sattenapalle', label: 'Sattenapalle' },
    { id: 'Pithapuram', label: 'Pithapuram' },
    { id: 'Palasa Kasibugga', label: 'Palasa Kasibugga' },
    { id: 'Parvathipuram', label: 'Parvathipuram' },
    { id: 'Macherla', label: 'Macherla' },
    { id: 'Gooty', label: 'Gooty' },
    { id: 'Salur', label: 'Salur' },
    { id: 'Mandapeta', label: 'Mandapeta' },
    { id: 'Jammalamadugu', label: 'Jammalamadugu' },
    { id: 'Peddapuram', label: 'Peddapuram' },
    { id: 'Punganur', label: 'Punganur' },
    { id: 'Nidadavole', label: 'Nidadavole' },
    { id: 'Repalle', label: 'Repalle' },
    { id: 'Ramachandrapuram', label: 'Ramachandrapuram' },
    { id: 'Kovvur', label: 'Kovvur' },
    { id: 'Tiruvuru', label: 'Tiruvuru' },
    { id: 'Uravakonda', label: 'Uravakonda' },
    { id: 'Narsipatnam', label: 'Narsipatnam' },
    { id: 'Yerraguntla', label: 'Yerraguntla' },
    { id: 'Pedana', label: 'Pedana' },
    { id: 'Puttur', label: 'Puttur' },
    { id: 'Renigunta', label: 'Renigunta' },
    { id: 'Rajam', label: 'Rajam' },
    {
      id: 'Srisailam Project (Right Flank Colony) Township',
      label: 'Srisailam Project (Right Flank Colony) Township',
    },
  ],
  Punjab: [
    { id: 'Ludhiana', label: 'Ludhiana' },
    { id: 'Patiala', label: 'Patiala' },
    { id: 'Amritsar', label: 'Amritsar' },
    { id: 'Jalandhar', label: 'Jalandhar' },
    { id: 'Bathinda', label: 'Bathinda' },
    { id: 'Pathankot', label: 'Pathankot' },
    { id: 'Hoshiarpur', label: 'Hoshiarpur' },
    { id: 'Batala', label: 'Batala' },
    { id: 'Moga', label: 'Moga' },
    { id: 'Malerkotla', label: 'Malerkotla' },
    { id: 'Khanna', label: 'Khanna' },
    { id: 'Mohali', label: 'Mohali' },
    { id: 'Barnala', label: 'Barnala' },
    { id: 'Firozpur', label: 'Firozpur' },
    { id: 'Phagwara', label: 'Phagwara' },
    { id: 'Kapurthala', label: 'Kapurthala' },
    { id: 'Zirakpur', label: 'Zirakpur' },
    { id: 'Kot Kapura', label: 'Kot Kapura' },
    { id: 'Faridkot', label: 'Faridkot' },
    { id: 'Muktsar', label: 'Muktsar' },
    { id: 'Rajpura', label: 'Rajpura' },
    { id: 'Sangrur', label: 'Sangrur' },
    { id: 'Fazilka', label: 'Fazilka' },
    { id: 'Gurdaspur', label: 'Gurdaspur' },
    { id: 'Kharar', label: 'Kharar' },
    { id: 'Gobindgarh', label: 'Gobindgarh' },
    { id: 'Mansa', label: 'Mansa' },
    { id: 'Malout', label: 'Malout' },
    { id: 'Nabha', label: 'Nabha' },
    { id: 'Tarn Taran', label: 'Tarn Taran' },
    { id: 'Jagraon', label: 'Jagraon' },
    { id: 'Sunam', label: 'Sunam' },
    { id: 'Dhuri', label: 'Dhuri' },
    { id: 'Firozpur Cantt.', label: 'Firozpur Cantt.' },
    { id: 'Sirhind Fatehgarh Sahib', label: 'Sirhind Fatehgarh Sahib' },
    { id: 'Rupnagar', label: 'Rupnagar' },
    { id: 'Jalandhar Cantt.', label: 'Jalandhar Cantt.' },
    { id: 'Samana', label: 'Samana' },
    { id: 'Nawanshahr', label: 'Nawanshahr' },
    { id: 'Rampura Phul', label: 'Rampura Phul' },
    { id: 'Nangal', label: 'Nangal' },
    { id: 'Nakodar', label: 'Nakodar' },
    { id: 'Zira', label: 'Zira' },
    { id: 'Patti', label: 'Patti' },
    { id: 'Raikot', label: 'Raikot' },
    { id: 'Longowal', label: 'Longowal' },
    { id: 'Urmar Tanda', label: 'Urmar Tanda' },
    { id: 'Morinda, India', label: 'Morinda, India' },
    { id: 'Phillaur', label: 'Phillaur' },
    { id: 'Pattran', label: 'Pattran' },
    { id: 'Qadian', label: 'Qadian' },
    { id: 'Sujanpur', label: 'Sujanpur' },
    { id: 'Mukerian', label: 'Mukerian' },
    { id: 'Talwara', label: 'Talwara' },
  ],
  Chandigarh: [{ id: 'Chandigarh', label: 'Chandigarh' }],
  Rajasthan: [
    { id: 'Jaipur', label: 'Jaipur' },
    { id: 'Jodhpur', label: 'Jodhpur' },
    { id: 'Bikaner', label: 'Bikaner' },
    { id: 'Udaipur', label: 'Udaipur' },
    { id: 'Ajmer', label: 'Ajmer' },
    { id: 'Bhilwara', label: 'Bhilwara' },
    { id: 'Alwar', label: 'Alwar' },
    { id: 'Bharatpur', label: 'Bharatpur' },
    { id: 'Pali', label: 'Pali' },
    { id: 'Barmer', label: 'Barmer' },
    { id: 'Sikar', label: 'Sikar' },
    { id: 'Tonk', label: 'Tonk' },
    { id: 'Sadulpur', label: 'Sadulpur' },
    { id: 'Sawai Madhopur', label: 'Sawai Madhopur' },
    { id: 'Nagaur', label: 'Nagaur' },
    { id: 'Makrana', label: 'Makrana' },
    { id: 'Sujangarh', label: 'Sujangarh' },
    { id: 'Sardarshahar', label: 'Sardarshahar' },
    { id: 'Ladnu', label: 'Ladnu' },
    { id: 'Ratangarh', label: 'Ratangarh' },
    { id: 'Nokha', label: 'Nokha' },
    { id: 'Nimbahera', label: 'Nimbahera' },
    { id: 'Suratgarh', label: 'Suratgarh' },
    { id: 'Rajsamand', label: 'Rajsamand' },
    { id: 'Lachhmangarh', label: 'Lachhmangarh' },
    { id: 'Rajgarh (Churu)', label: 'Rajgarh (Churu)' },
    { id: 'Nasirabad', label: 'Nasirabad' },
    { id: 'Nohar', label: 'Nohar' },
    { id: 'Phalodi', label: 'Phalodi' },
    { id: 'Nathdwara', label: 'Nathdwara' },
    { id: 'Pilani', label: 'Pilani' },
    { id: 'Merta City', label: 'Merta City' },
    { id: 'Sojat', label: 'Sojat' },
    { id: 'Neem-Ka-Thana', label: 'Neem-Ka-Thana' },
    { id: 'Sirohi', label: 'Sirohi' },
    { id: 'Pratapgarh', label: 'Pratapgarh' },
    { id: 'Rawatbhata', label: 'Rawatbhata' },
    { id: 'Sangaria', label: 'Sangaria' },
    { id: 'Lalsot', label: 'Lalsot' },
    { id: 'Pilibanga', label: 'Pilibanga' },
    { id: 'Pipar City', label: 'Pipar City' },
    { id: 'Taranagar', label: 'Taranagar' },
    { id: 'Vijainagar, Ajmer', label: 'Vijainagar, Ajmer' },
    { id: 'Sumerpur', label: 'Sumerpur' },
    { id: 'Sagwara', label: 'Sagwara' },
    { id: 'Ramganj Mandi', label: 'Ramganj Mandi' },
    { id: 'Lakheri', label: 'Lakheri' },
    { id: 'Udaipurwati', label: 'Udaipurwati' },
    { id: 'Losal', label: 'Losal' },
    { id: 'Sri Madhopur', label: 'Sri Madhopur' },
    { id: 'Ramngarh', label: 'Ramngarh' },
    { id: 'Rawatsar', label: 'Rawatsar' },
    { id: 'Rajakhera', label: 'Rajakhera' },
    { id: 'Shahpura', label: 'Shahpura' },
    { id: 'Shahpura', label: 'Shahpura' },
    { id: 'Raisinghnagar', label: 'Raisinghnagar' },
    { id: 'Malpura', label: 'Malpura' },
    { id: 'Nadbai', label: 'Nadbai' },
    { id: 'Sanchore', label: 'Sanchore' },
    { id: 'Nagar', label: 'Nagar' },
    { id: 'Rajgarh (Alwar)', label: 'Rajgarh (Alwar)' },
    { id: 'Sheoganj', label: 'Sheoganj' },
    { id: 'Sadri', label: 'Sadri' },
    { id: 'Todaraisingh', label: 'Todaraisingh' },
    { id: 'Todabhim', label: 'Todabhim' },
    { id: 'Reengus', label: 'Reengus' },
    { id: 'Rajaldesar', label: 'Rajaldesar' },
    { id: 'Sadulshahar', label: 'Sadulshahar' },
    { id: 'Sambhar', label: 'Sambhar' },
    { id: 'Prantij', label: 'Prantij' },
    { id: 'Mount Abu', label: 'Mount Abu' },
    { id: 'Mangrol', label: 'Mangrol' },
    { id: 'Phulera', label: 'Phulera' },
    { id: 'Mandawa', label: 'Mandawa' },
    { id: 'Pindwara', label: 'Pindwara' },
    { id: 'Mandalgarh', label: 'Mandalgarh' },
    { id: 'Takhatgarh', label: 'Takhatgarh' },
  ],
  Assam: [
    { id: 'Guwahati', label: 'Guwahati' },
    { id: 'Silchar', label: 'Silchar' },
    { id: 'Dibrugarh', label: 'Dibrugarh' },
    { id: 'Nagaon', label: 'Nagaon' },
    { id: 'Tinsukia', label: 'Tinsukia' },
    { id: 'Jorhat', label: 'Jorhat' },
    { id: 'Bongaigaon City', label: 'Bongaigaon City' },
    { id: 'Dhubri', label: 'Dhubri' },
    { id: 'Diphu', label: 'Diphu' },
    { id: 'North Lakhimpur', label: 'North Lakhimpur' },
    { id: 'Tezpur', label: 'Tezpur' },
    { id: 'Karimganj', label: 'Karimganj' },
    { id: 'Sibsagar', label: 'Sibsagar' },
    { id: 'Goalpara', label: 'Goalpara' },
    { id: 'Barpeta', label: 'Barpeta' },
    { id: 'Lanka', label: 'Lanka' },
    { id: 'Lumding', label: 'Lumding' },
    { id: 'Mankachar', label: 'Mankachar' },
    { id: 'Nalbari', label: 'Nalbari' },
    { id: 'Rangia', label: 'Rangia' },
    { id: 'Margherita', label: 'Margherita' },
    { id: 'Mangaldoi', label: 'Mangaldoi' },
    { id: 'Silapathar', label: 'Silapathar' },
    { id: 'Mariani', label: 'Mariani' },
    { id: 'Marigaon', label: 'Marigaon' },
  ],
  Odisha: [
    { id: 'Bhubaneswar', label: 'Bhubaneswar' },
    { id: 'Cuttack', label: 'Cuttack' },
    { id: 'Raurkela', label: 'Raurkela' },
    { id: 'Brahmapur', label: 'Brahmapur' },
    { id: 'Sambalpur', label: 'Sambalpur' },
    { id: 'Puri', label: 'Puri' },
    { id: 'Baleshwar Town', label: 'Baleshwar Town' },
    { id: 'Baripada Town', label: 'Baripada Town' },
    { id: 'Bhadrak', label: 'Bhadrak' },
    { id: 'Balangir', label: 'Balangir' },
    { id: 'Jharsuguda', label: 'Jharsuguda' },
    { id: 'Bargarh', label: 'Bargarh' },
    { id: 'Paradip', label: 'Paradip' },
    { id: 'Bhawanipatna', label: 'Bhawanipatna' },
    { id: 'Dhenkanal', label: 'Dhenkanal' },
    { id: 'Barbil', label: 'Barbil' },
    { id: 'Kendujhar', label: 'Kendujhar' },
    { id: 'Sunabeda', label: 'Sunabeda' },
    { id: 'Rayagada', label: 'Rayagada' },
    { id: 'Jatani', label: 'Jatani' },
    { id: 'Byasanagar', label: 'Byasanagar' },
    { id: 'Kendrapara', label: 'Kendrapara' },
    { id: 'Rajagangapur', label: 'Rajagangapur' },
    { id: 'Parlakhemundi', label: 'Parlakhemundi' },
    { id: 'Talcher', label: 'Talcher' },
    { id: 'Sundargarh', label: 'Sundargarh' },
    { id: 'Phulabani', label: 'Phulabani' },
    { id: 'Pattamundai', label: 'Pattamundai' },
    { id: 'Titlagarh', label: 'Titlagarh' },
    { id: 'Nabarangapur', label: 'Nabarangapur' },
    { id: 'Soro', label: 'Soro' },
    { id: 'Malkangiri', label: 'Malkangiri' },
    { id: 'Rairangpur', label: 'Rairangpur' },
    { id: 'Tarbha', label: 'Tarbha' },
  ],
  Chhattisgarh: [
    { id: 'Raipur', label: 'Raipur' },
    { id: 'Bhilai Nagar', label: 'Bhilai Nagar' },
    { id: 'Korba', label: 'Korba' },
    { id: 'Bilaspur', label: 'Bilaspur' },
    { id: 'Durg', label: 'Durg' },
    { id: 'Rajnandgaon', label: 'Rajnandgaon' },
    { id: 'Jagdalpur', label: 'Jagdalpur' },
    { id: 'Raigarh', label: 'Raigarh' },
    { id: 'Ambikapur', label: 'Ambikapur' },
    { id: 'Mahasamund', label: 'Mahasamund' },
    { id: 'Dhamtari', label: 'Dhamtari' },
    { id: 'Chirmiri', label: 'Chirmiri' },
    { id: 'Bhatapara', label: 'Bhatapara' },
    { id: 'Dalli-Rajhara', label: 'Dalli-Rajhara' },
    { id: 'Naila Janjgir', label: 'Naila Janjgir' },
    { id: 'Tilda Newra', label: 'Tilda Newra' },
    { id: 'Mungeli', label: 'Mungeli' },
    { id: 'Manendragarh', label: 'Manendragarh' },
    { id: 'Sakti', label: 'Sakti' },
  ],
  'Jammu and Kashmir': [
    { id: 'Srinagar', label: 'Srinagar' },
    { id: 'Jammu', label: 'Jammu' },
    { id: 'Baramula', label: 'Baramula' },
    { id: 'Anantnag', label: 'Anantnag' },
    { id: 'Sopore', label: 'Sopore' },
    { id: 'KathUrban Agglomeration', label: 'KathUrban Agglomeration' },
    { id: 'Rajauri', label: 'Rajauri' },
    { id: 'Punch', label: 'Punch' },
    { id: 'Udhampur', label: 'Udhampur' },
  ],
  Karnataka: [
    { id: 'Bengaluru', label: 'Bengaluru' },
    { id: 'Hubli-Dharwad', label: 'Hubli-Dharwad' },
    { id: 'Belagavi', label: 'Belagavi' },
    { id: 'Mangaluru', label: 'Mangaluru' },
    { id: 'Davanagere', label: 'Davanagere' },
    { id: 'Ballari', label: 'Ballari' },
    { id: 'Mysore', label: 'Mysore' },
    { id: 'Tumkur', label: 'Tumkur' },
    { id: 'Shivamogga', label: 'Shivamogga' },
    { id: 'Raayachuru', label: 'Raayachuru' },
    { id: 'Robertson Pet', label: 'Robertson Pet' },
    { id: 'Kolar', label: 'Kolar' },
    { id: 'Mandya', label: 'Mandya' },
    { id: 'Udupi', label: 'Udupi' },
    { id: 'Chikkamagaluru', label: 'Chikkamagaluru' },
    { id: 'Karwar', label: 'Karwar' },
    { id: 'Ranebennuru', label: 'Ranebennuru' },
    { id: 'Ranibennur', label: 'Ranibennur' },
    { id: 'Ramanagaram', label: 'Ramanagaram' },
    { id: 'Gokak', label: 'Gokak' },
    { id: 'Yadgir', label: 'Yadgir' },
    { id: 'Rabkavi Banhatti', label: 'Rabkavi Banhatti' },
    { id: 'Shahabad', label: 'Shahabad' },
    { id: 'Sirsi', label: 'Sirsi' },
    { id: 'Sindhnur', label: 'Sindhnur' },
    { id: 'Tiptur', label: 'Tiptur' },
    { id: 'Arsikere', label: 'Arsikere' },
    { id: 'Nanjangud', label: 'Nanjangud' },
    { id: 'Sagara', label: 'Sagara' },
    { id: 'Sira', label: 'Sira' },
    { id: 'Puttur', label: 'Puttur' },
    { id: 'Athni', label: 'Athni' },
    { id: 'Mulbagal', label: 'Mulbagal' },
    { id: 'Surapura', label: 'Surapura' },
    { id: 'Siruguppa', label: 'Siruguppa' },
    { id: 'Mudhol', label: 'Mudhol' },
    { id: 'Sidlaghatta', label: 'Sidlaghatta' },
    { id: 'Shahpur', label: 'Shahpur' },
    { id: 'Saundatti-Yellamma', label: 'Saundatti-Yellamma' },
    { id: 'Wadi', label: 'Wadi' },
    { id: 'Manvi', label: 'Manvi' },
    { id: 'Nelamangala', label: 'Nelamangala' },
    { id: 'Lakshmeshwar', label: 'Lakshmeshwar' },
    { id: 'Ramdurg', label: 'Ramdurg' },
    { id: 'Nargund', label: 'Nargund' },
    { id: 'Tarikere', label: 'Tarikere' },
    { id: 'Malavalli', label: 'Malavalli' },
    { id: 'Savanur', label: 'Savanur' },
    { id: 'Lingsugur', label: 'Lingsugur' },
    { id: 'Vijayapura', label: 'Vijayapura' },
    { id: 'Sankeshwara', label: 'Sankeshwara' },
    { id: 'Madikeri', label: 'Madikeri' },
    { id: 'Talikota', label: 'Talikota' },
    { id: 'Sedam', label: 'Sedam' },
    { id: 'Shikaripur', label: 'Shikaripur' },
    { id: 'Mahalingapura', label: 'Mahalingapura' },
    { id: 'Mudalagi', label: 'Mudalagi' },
    { id: 'Muddebihal', label: 'Muddebihal' },
    { id: 'Pavagada', label: 'Pavagada' },
    { id: 'Malur', label: 'Malur' },
    { id: 'Sindhagi', label: 'Sindhagi' },
    { id: 'Sanduru', label: 'Sanduru' },
    { id: 'Afzalpur', label: 'Afzalpur' },
    { id: 'Maddur', label: 'Maddur' },
    { id: 'Madhugiri', label: 'Madhugiri' },
    { id: 'Tekkalakote', label: 'Tekkalakote' },
    { id: 'Terdal', label: 'Terdal' },
    { id: 'Mudabidri', label: 'Mudabidri' },
    { id: 'Magadi', label: 'Magadi' },
    { id: 'Navalgund', label: 'Navalgund' },
    { id: 'Shiggaon', label: 'Shiggaon' },
    { id: 'Shrirangapattana', label: 'Shrirangapattana' },
    { id: 'Sindagi', label: 'Sindagi' },
    { id: 'Sakaleshapura', label: 'Sakaleshapura' },
    { id: 'Srinivaspur', label: 'Srinivaspur' },
    { id: 'Ron', label: 'Ron' },
    { id: 'Mundargi', label: 'Mundargi' },
    { id: 'Sadalagi', label: 'Sadalagi' },
    { id: 'Piriyapatna', label: 'Piriyapatna' },
    { id: 'Adyar', label: 'Adyar' },
  ],
  Manipur: [
    { id: 'Imphal', label: 'Imphal' },
    { id: 'Thoubal', label: 'Thoubal' },
    { id: 'Lilong', label: 'Lilong' },
    { id: 'Mayang Imphal', label: 'Mayang Imphal' },
  ],
  Kerala: [
    { id: 'Thiruvananthapuram', label: 'Thiruvananthapuram' },
    { id: 'Kochi', label: 'Kochi' },
    { id: 'Kozhikode', label: 'Kozhikode' },
    { id: 'Kollam', label: 'Kollam' },
    { id: 'Thrissur', label: 'Thrissur' },
    { id: 'Palakkad', label: 'Palakkad' },
    { id: 'Alappuzha', label: 'Alappuzha' },
    { id: 'Malappuram', label: 'Malappuram' },
    { id: 'Ponnani', label: 'Ponnani' },
    { id: 'Vatakara', label: 'Vatakara' },
    { id: 'Kanhangad', label: 'Kanhangad' },
    { id: 'Taliparamba', label: 'Taliparamba' },
    { id: 'Koyilandy', label: 'Koyilandy' },
    { id: 'Neyyattinkara', label: 'Neyyattinkara' },
    { id: 'Kayamkulam', label: 'Kayamkulam' },
    { id: 'Nedumangad', label: 'Nedumangad' },
    { id: 'Kannur', label: 'Kannur' },
    { id: 'Tirur', label: 'Tirur' },
    { id: 'Kottayam', label: 'Kottayam' },
    { id: 'Kasaragod', label: 'Kasaragod' },
    { id: 'Kunnamkulam', label: 'Kunnamkulam' },
    { id: 'Ottappalam', label: 'Ottappalam' },
    { id: 'Thiruvalla', label: 'Thiruvalla' },
    { id: 'Thodupuzha', label: 'Thodupuzha' },
    { id: 'Chalakudy', label: 'Chalakudy' },
    { id: 'Changanassery', label: 'Changanassery' },
    { id: 'Punalur', label: 'Punalur' },
    { id: 'Nilambur', label: 'Nilambur' },
    { id: 'Cherthala', label: 'Cherthala' },
    { id: 'Perinthalmanna', label: 'Perinthalmanna' },
    { id: 'Mattannur', label: 'Mattannur' },
    { id: 'Shoranur', label: 'Shoranur' },
    { id: 'Varkala', label: 'Varkala' },
    { id: 'Paravoor', label: 'Paravoor' },
    { id: 'Pathanamthitta', label: 'Pathanamthitta' },
    { id: 'Peringathur', label: 'Peringathur' },
    { id: 'Attingal', label: 'Attingal' },
    { id: 'Kodungallur', label: 'Kodungallur' },
    { id: 'Pappinisseri', label: 'Pappinisseri' },
    { id: 'Chittur-Thathamangalam', label: 'Chittur-Thathamangalam' },
    { id: 'Muvattupuzha', label: 'Muvattupuzha' },
    { id: 'Adoor', label: 'Adoor' },
    { id: 'Mavelikkara', label: 'Mavelikkara' },
    { id: 'Mavoor', label: 'Mavoor' },
    { id: 'Perumbavoor', label: 'Perumbavoor' },
    { id: 'Vaikom', label: 'Vaikom' },
    { id: 'Palai', label: 'Palai' },
    { id: 'Panniyannur', label: 'Panniyannur' },
    { id: 'Guruvayoor', label: 'Guruvayoor' },
    { id: 'Puthuppally', label: 'Puthuppally' },
    { id: 'Panamattom', label: 'Panamattom' },
  ],
  Delhi: [
    { id: 'Delhi', label: 'Delhi' },
    { id: 'New Delhi', label: 'New Delhi' },
  ],
  'Dadra and Nagar Haveli': [{ id: 'Silvassa', label: 'Silvassa' }],
  Puducherry: [
    { id: 'Pondicherry', label: 'Pondicherry' },
    { id: 'Karaikal', label: 'Karaikal' },
    { id: 'Yanam', label: 'Yanam' },
    { id: 'Mahe', label: 'Mahe' },
  ],
  Uttarakhand: [
    { id: 'Dehradun', label: 'Dehradun' },
    { id: 'Hardwar', label: 'Hardwar' },
    { id: 'Haldwani-cum-Kathgodam', label: 'Haldwani-cum-Kathgodam' },
    { id: 'Srinagar', label: 'Srinagar' },
    { id: 'Kashipur', label: 'Kashipur' },
    { id: 'Roorkee', label: 'Roorkee' },
    { id: 'Rudrapur', label: 'Rudrapur' },
    { id: 'Rishikesh', label: 'Rishikesh' },
    { id: 'Ramnagar', label: 'Ramnagar' },
    { id: 'Pithoragarh', label: 'Pithoragarh' },
    { id: 'Manglaur', label: 'Manglaur' },
    { id: 'Nainital', label: 'Nainital' },
    { id: 'Mussoorie', label: 'Mussoorie' },
    { id: 'Tehri', label: 'Tehri' },
    { id: 'Pauri', label: 'Pauri' },
    { id: 'Nagla', label: 'Nagla' },
    { id: 'Sitarganj', label: 'Sitarganj' },
    { id: 'Bageshwar', label: 'Bageshwar' },
  ],
  'Uttar Pradesh': [
    { id: 'Lucknow', label: 'Lucknow' },
    { id: 'Kanpur', label: 'Kanpur' },
    { id: 'Firozabad', label: 'Firozabad' },
    { id: 'Agra', label: 'Agra' },
    { id: 'Meerut', label: 'Meerut' },
    { id: 'Varanasi', label: 'Varanasi' },
    { id: 'Allahabad', label: 'Allahabad' },
    { id: 'Amroha', label: 'Amroha' },
    { id: 'Moradabad', label: 'Moradabad' },
    { id: 'Aligarh', label: 'Aligarh' },
    { id: 'Saharanpur', label: 'Saharanpur' },
    { id: 'Noida', label: 'Noida' },
    { id: 'Loni', label: 'Loni' },
    { id: 'Jhansi', label: 'Jhansi' },
    { id: 'Shahjahanpur', label: 'Shahjahanpur' },
    { id: 'Rampur', label: 'Rampur' },
    { id: 'Modinagar', label: 'Modinagar' },
    { id: 'Hapur', label: 'Hapur' },
    { id: 'Etawah', label: 'Etawah' },
    { id: 'Sambhal', label: 'Sambhal' },
    { id: 'Orai', label: 'Orai' },
    { id: 'Bahraich', label: 'Bahraich' },
    { id: 'Unnao', label: 'Unnao' },
    { id: 'Rae Bareli', label: 'Rae Bareli' },
    { id: 'Lakhimpur', label: 'Lakhimpur' },
    { id: 'Sitapur', label: 'Sitapur' },
    { id: 'Lalitpur', label: 'Lalitpur' },
    { id: 'Pilibhit', label: 'Pilibhit' },
    { id: 'Chandausi', label: 'Chandausi' },
    { id: 'Hardoi ', label: 'Hardoi ' },
    { id: 'Azamgarh', label: 'Azamgarh' },
    { id: 'Khair', label: 'Khair' },
    { id: 'Sultanpur', label: 'Sultanpur' },
    { id: 'Tanda', label: 'Tanda' },
    { id: 'Nagina', label: 'Nagina' },
    { id: 'Shamli', label: 'Shamli' },
    { id: 'Najibabad', label: 'Najibabad' },
    { id: 'Shikohabad', label: 'Shikohabad' },
    { id: 'Sikandrabad', label: 'Sikandrabad' },
    { id: 'Shahabad, Hardoi', label: 'Shahabad, Hardoi' },
    { id: 'Pilkhuwa', label: 'Pilkhuwa' },
    { id: 'Renukoot', label: 'Renukoot' },
    { id: 'Vrindavan', label: 'Vrindavan' },
    { id: 'Ujhani', label: 'Ujhani' },
    { id: 'Laharpur', label: 'Laharpur' },
    { id: 'Tilhar', label: 'Tilhar' },
    { id: 'Sahaswan', label: 'Sahaswan' },
    { id: 'Rath', label: 'Rath' },
    { id: 'Sherkot', label: 'Sherkot' },
    { id: 'Kalpi', label: 'Kalpi' },
    { id: 'Tundla', label: 'Tundla' },
    { id: 'Sandila', label: 'Sandila' },
    { id: 'Nanpara', label: 'Nanpara' },
    { id: 'Sardhana', label: 'Sardhana' },
    { id: 'Nehtaur', label: 'Nehtaur' },
    { id: 'Seohara', label: 'Seohara' },
    { id: 'Padrauna', label: 'Padrauna' },
    { id: 'Mathura', label: 'Mathura' },
    { id: 'Thakurdwara', label: 'Thakurdwara' },
    { id: 'Nawabganj', label: 'Nawabganj' },
    { id: 'Siana', label: 'Siana' },
    { id: 'Noorpur', label: 'Noorpur' },
    { id: 'Sikandra Rao', label: 'Sikandra Rao' },
    { id: 'Puranpur', label: 'Puranpur' },
    { id: 'Rudauli', label: 'Rudauli' },
    { id: 'Thana Bhawan', label: 'Thana Bhawan' },
    { id: 'Palia Kalan', label: 'Palia Kalan' },
    { id: 'Zaidpur', label: 'Zaidpur' },
    { id: 'Nautanwa', label: 'Nautanwa' },
    { id: 'Zamania', label: 'Zamania' },
    { id: 'Shikarpur, Bulandshahr', label: 'Shikarpur, Bulandshahr' },
    { id: 'Naugawan Sadat', label: 'Naugawan Sadat' },
    { id: 'Fatehpur Sikri', label: 'Fatehpur Sikri' },
    { id: 'Shahabad, Rampur', label: 'Shahabad, Rampur' },
    { id: 'Robertsganj', label: 'Robertsganj' },
    { id: 'Utraula', label: 'Utraula' },
    { id: 'Sadabad', label: 'Sadabad' },
    { id: 'Rasra', label: 'Rasra' },
    { id: 'Lar', label: 'Lar' },
    { id: 'Lal Gopalganj Nindaura', label: 'Lal Gopalganj Nindaura' },
    { id: 'Sirsaganj', label: 'Sirsaganj' },
    { id: 'Pihani', label: 'Pihani' },
    { id: 'Shamsabad, Agra', label: 'Shamsabad, Agra' },
    { id: 'Rudrapur', label: 'Rudrapur' },
    { id: 'Soron', label: 'Soron' },
    { id: 'SUrban Agglomerationr', label: 'SUrban Agglomerationr' },
    { id: 'Samdhan', label: 'Samdhan' },
    { id: 'Sahjanwa', label: 'Sahjanwa' },
    { id: 'Rampur Maniharan', label: 'Rampur Maniharan' },
    { id: 'Sumerpur', label: 'Sumerpur' },
    { id: 'Shahganj', label: 'Shahganj' },
    { id: 'Tulsipur', label: 'Tulsipur' },
    { id: 'Tirwaganj', label: 'Tirwaganj' },
    { id: 'PurqUrban Agglomerationzi', label: 'PurqUrban Agglomerationzi' },
    { id: 'Shamsabad, Farrukhabad', label: 'Shamsabad, Farrukhabad' },
    { id: 'Warhapur', label: 'Warhapur' },
    { id: 'Powayan', label: 'Powayan' },
    { id: 'Sandi', label: 'Sandi' },
    { id: 'Achhnera', label: 'Achhnera' },
    { id: 'Naraura', label: 'Naraura' },
    { id: 'Nakur', label: 'Nakur' },
    { id: 'Sahaspur', label: 'Sahaspur' },
    { id: 'Safipur', label: 'Safipur' },
    { id: 'Reoti', label: 'Reoti' },
    { id: 'Sikanderpur', label: 'Sikanderpur' },
    { id: 'Saidpur', label: 'Saidpur' },
    { id: 'Sirsi', label: 'Sirsi' },
    { id: 'Purwa', label: 'Purwa' },
    { id: 'Parasi', label: 'Parasi' },
    { id: 'Lalganj', label: 'Lalganj' },
    { id: 'Phulpur', label: 'Phulpur' },
    { id: 'Shishgarh', label: 'Shishgarh' },
    { id: 'Sahawar', label: 'Sahawar' },
    { id: 'Samthar', label: 'Samthar' },
    { id: 'Pukhrayan', label: 'Pukhrayan' },
    { id: 'Obra', label: 'Obra' },
    { id: 'Niwai', label: 'Niwai' },
    { id: 'Mirzapur', label: 'Mirzapur' },
  ],
  Bihar: [
    { id: 'Patna', label: 'Patna' },
    { id: 'Gaya', label: 'Gaya' },
    { id: 'Bhagalpur', label: 'Bhagalpur' },
    { id: 'Muzaffarpur', label: 'Muzaffarpur' },
    { id: 'Darbhanga', label: 'Darbhanga' },
    { id: 'Arrah', label: 'Arrah' },
    { id: 'Begusarai', label: 'Begusarai' },
    { id: 'Chhapra', label: 'Chhapra' },
    { id: 'Katihar', label: 'Katihar' },
    { id: 'Munger', label: 'Munger' },
    { id: 'Purnia', label: 'Purnia' },
    { id: 'Saharsa', label: 'Saharsa' },
    { id: 'Sasaram', label: 'Sasaram' },
    { id: 'Hajipur', label: 'Hajipur' },
    { id: 'Dehri-on-Sone', label: 'Dehri-on-Sone' },
    { id: 'Bettiah', label: 'Bettiah' },
    { id: 'Motihari', label: 'Motihari' },
    { id: 'Bagaha', label: 'Bagaha' },
    { id: 'Siwan', label: 'Siwan' },
    { id: 'Kishanganj', label: 'Kishanganj' },
    { id: 'Jamalpur', label: 'Jamalpur' },
    { id: 'Buxar', label: 'Buxar' },
    { id: 'Jehanabad', label: 'Jehanabad' },
    { id: 'Aurangabad', label: 'Aurangabad' },
    { id: 'Lakhisarai', label: 'Lakhisarai' },
    { id: 'Nawada', label: 'Nawada' },
    { id: 'Jamui', label: 'Jamui' },
    { id: 'Sitamarhi', label: 'Sitamarhi' },
    { id: 'Araria', label: 'Araria' },
    { id: 'Gopalganj', label: 'Gopalganj' },
    { id: 'Madhubani', label: 'Madhubani' },
    { id: 'Masaurhi', label: 'Masaurhi' },
    { id: 'Samastipur', label: 'Samastipur' },
    { id: 'Mokameh', label: 'Mokameh' },
    { id: 'Supaul', label: 'Supaul' },
    { id: 'Dumraon', label: 'Dumraon' },
    { id: 'Arwal', label: 'Arwal' },
    { id: 'Forbesganj', label: 'Forbesganj' },
    { id: 'BhabUrban Agglomeration', label: 'BhabUrban Agglomeration' },
    { id: 'Narkatiaganj', label: 'Narkatiaganj' },
    { id: 'Naugachhia', label: 'Naugachhia' },
    { id: 'Madhepura', label: 'Madhepura' },
    { id: 'Sheikhpura', label: 'Sheikhpura' },
    { id: 'Sultanganj', label: 'Sultanganj' },
    { id: 'Raxaul Bazar', label: 'Raxaul Bazar' },
    { id: 'Ramnagar', label: 'Ramnagar' },
    { id: 'Mahnar Bazar', label: 'Mahnar Bazar' },
    { id: 'Warisaliganj', label: 'Warisaliganj' },
    { id: 'Revelganj', label: 'Revelganj' },
    { id: 'Rajgir', label: 'Rajgir' },
    { id: 'Sonepur', label: 'Sonepur' },
    { id: 'Sherghati', label: 'Sherghati' },
    { id: 'Sugauli', label: 'Sugauli' },
    { id: 'Makhdumpur', label: 'Makhdumpur' },
    { id: 'Maner', label: 'Maner' },
    { id: 'Rosera', label: 'Rosera' },
    { id: 'Nokha', label: 'Nokha' },
    { id: 'Piro', label: 'Piro' },
    { id: 'Rafiganj', label: 'Rafiganj' },
    { id: 'Marhaura', label: 'Marhaura' },
    { id: 'Mirganj', label: 'Mirganj' },
    { id: 'Lalganj', label: 'Lalganj' },
    { id: 'Murliganj', label: 'Murliganj' },
    { id: 'Motipur', label: 'Motipur' },
    { id: 'Manihari', label: 'Manihari' },
    { id: 'Sheohar', label: 'Sheohar' },
    { id: 'Maharajganj', label: 'Maharajganj' },
    { id: 'Silao', label: 'Silao' },
    { id: 'Barh', label: 'Barh' },
    { id: 'Asarganj', label: 'Asarganj' },
  ],
  Gujarat: [
    { id: 'Ahmedabad', label: 'Ahmedabad' },
    { id: 'Amreli', label: 'Amreli' },
    { id: 'Anand', label: 'Anand' },
    { id: 'Aravalli', label: 'Aravalli' },
    { id: 'Banaskantha', label: 'Banaskantha' },
    { id: 'Bharuch', label: 'Bharuch' },
    { id: 'Bhavnagar', label: 'Bhavnagar' },
    { id: 'Botad', label: 'Botad' },
    { id: 'Chhota Udaipur', label: 'Chhota Udaipur' },
    { id: 'Dahod', label: 'Dahod' },
    { id: 'Dang', label: 'Dang' },
    { id: 'Devbhumi Dwarka', label: 'Devbhumi Dwarka' },
    { id: 'Gandhinagar', label: 'Gandhinagar' },
    { id: 'Gir Somnath', label: 'Gir Somnath' },
    { id: 'Jamnagar', label: 'Jamnagar' },
    { id: 'Junagadh', label: 'Junagadh' },
    { id: 'Kheda', label: 'Kheda' },
    { id: 'Kutch', label: 'Kutch' },
    { id: 'Mahisagar', label: 'Mahisagar' },
    { id: 'Mahesana', label: 'Mahesana' },
    { id: 'Morbi', label: 'Morbi' },
    { id: 'Narmada', label: 'Narmada' },
    { id: 'Navsari', label: 'Navsari' },
    { id: 'Panchmahal', label: 'Panchmahal' },
    { id: 'Patan', label: 'Patan' },
    { id: 'Porbandar', label: 'Porbandar' },
    { id: 'Rajkot', label: 'Rajkot' },
    { id: 'Sabarkantha', label: 'Sabarkantha' },
    { id: 'Surat', label: 'Surat' },
    { id: 'Surendranagar', label: 'Surendranagar' },
    { id: 'Tapi', label: 'Tapi' },
    { id: 'Vadodara', label: 'Vadodara' },
    { id: 'Valsad', label: 'Valsad' },
  ],
  Telangana: [
    { id: 'Hyderabad', label: 'Hyderabad' },
    { id: 'Warangal', label: 'Warangal' },
    { id: 'Nizamabad', label: 'Nizamabad' },
    { id: 'Karimnagar', label: 'Karimnagar' },
    { id: 'Ramagundam', label: 'Ramagundam' },
    { id: 'Khammam', label: 'Khammam' },
    { id: 'Mahbubnagar', label: 'Mahbubnagar' },
    { id: 'Mancherial', label: 'Mancherial' },
    { id: 'Adilabad', label: 'Adilabad' },
    { id: 'Suryapet', label: 'Suryapet' },
    { id: 'Jagtial', label: 'Jagtial' },
    { id: 'Miryalaguda', label: 'Miryalaguda' },
    { id: 'Nirmal', label: 'Nirmal' },
    { id: 'Kamareddy', label: 'Kamareddy' },
    { id: 'Kothagudem', label: 'Kothagudem' },
    { id: 'Bodhan', label: 'Bodhan' },
    { id: 'Palwancha', label: 'Palwancha' },
    { id: 'Mandamarri', label: 'Mandamarri' },
    { id: 'Koratla', label: 'Koratla' },
    { id: 'Sircilla', label: 'Sircilla' },
    { id: 'Tandur', label: 'Tandur' },
    { id: 'Siddipet', label: 'Siddipet' },
    { id: 'Wanaparthy', label: 'Wanaparthy' },
    { id: 'Kagaznagar', label: 'Kagaznagar' },
    { id: 'Gadwal', label: 'Gadwal' },
    { id: 'Sangareddy', label: 'Sangareddy' },
    { id: 'Bellampalle', label: 'Bellampalle' },
    { id: 'Bhongir', label: 'Bhongir' },
    { id: 'Vikarabad', label: 'Vikarabad' },
    { id: 'Jangaon', label: 'Jangaon' },
    { id: 'Bhadrachalam', label: 'Bhadrachalam' },
    { id: 'Bhainsa', label: 'Bhainsa' },
    { id: 'Farooqnagar', label: 'Farooqnagar' },
    { id: 'Medak', label: 'Medak' },
    { id: 'Narayanpet', label: 'Narayanpet' },
    { id: 'Sadasivpet', label: 'Sadasivpet' },
    { id: 'Yellandu', label: 'Yellandu' },
    { id: 'Manuguru', label: 'Manuguru' },
    { id: 'Kyathampalle', label: 'Kyathampalle' },
    { id: 'Nagarkurnool', label: 'Nagarkurnool' },
  ],
  Meghalaya: [
    { id: 'Shillong', label: 'Shillong' },
    { id: 'Tura', label: 'Tura' },
    { id: 'Nongstoin', label: 'Nongstoin' },
  ],
  'Himachal Praddesh': [{ id: 'Manali', label: 'Manali' }],
  'Arunachal Pradesh': [
    { id: 'Naharlagun', label: 'Naharlagun' },
    { id: 'Pasighat', label: 'Pasighat' },
  ],
  Maharashtra: [
    { id: 'Mumbai', label: 'Mumbai' },
    { id: 'Pune', label: 'Pune' },
    { id: 'Nagpur', label: 'Nagpur' },
    { id: 'Thane', label: 'Thane' },
    { id: 'Nashik', label: 'Nashik' },
    { id: 'Kalyan-Dombivali', label: 'Kalyan-Dombivali' },
    { id: 'Vasai-Virar', label: 'Vasai-Virar' },
    { id: 'Solapur', label: 'Solapur' },
    { id: 'Mira-Bhayandar', label: 'Mira-Bhayandar' },
    { id: 'Bhiwandi', label: 'Bhiwandi' },
    { id: 'Amravati', label: 'Amravati' },
    { id: 'Nanded-Waghala', label: 'Nanded-Waghala' },
    { id: 'Sangli', label: 'Sangli' },
    { id: 'Malegaon', label: 'Malegaon' },
    { id: 'Akola', label: 'Akola' },
    { id: 'Latur', label: 'Latur' },
    { id: 'Dhule', label: 'Dhule' },
    { id: 'Ahmednagar', label: 'Ahmednagar' },
    { id: 'Ichalkaranji', label: 'Ichalkaranji' },
    { id: 'Parbhani', label: 'Parbhani' },
    { id: 'Panvel', label: 'Panvel' },
    { id: 'Yavatmal', label: 'Yavatmal' },
    { id: 'Achalpur', label: 'Achalpur' },
    { id: 'Osmanabad', label: 'Osmanabad' },
    { id: 'Nandurbar', label: 'Nandurbar' },
    { id: 'Satara', label: 'Satara' },
    { id: 'Wardha', label: 'Wardha' },
    { id: 'Udgir', label: 'Udgir' },
    { id: 'Aurangabad', label: 'Aurangabad' },
    { id: 'Amalner', label: 'Amalner' },
    { id: 'Akot', label: 'Akot' },
    { id: 'Pandharpur', label: 'Pandharpur' },
    { id: 'Shrirampur', label: 'Shrirampur' },
    { id: 'Parli', label: 'Parli' },
    { id: 'Washim', label: 'Washim' },
    { id: 'Ambejogai', label: 'Ambejogai' },
    { id: 'Manmad', label: 'Manmad' },
    { id: 'Ratnagiri', label: 'Ratnagiri' },
    { id: 'Uran Islampur', label: 'Uran Islampur' },
    { id: 'Pusad', label: 'Pusad' },
    { id: 'Sangamner', label: 'Sangamner' },
    { id: 'Shirpur-Warwade', label: 'Shirpur-Warwade' },
    { id: 'Malkapur', label: 'Malkapur' },
    { id: 'Wani', label: 'Wani' },
    { id: 'Lonavla', label: 'Lonavla' },
    { id: 'Talegaon Dabhade', label: 'Talegaon Dabhade' },
    { id: 'Anjangaon', label: 'Anjangaon' },
    { id: 'Umred', label: 'Umred' },
    { id: 'Palghar', label: 'Palghar' },
    { id: 'Shegaon', label: 'Shegaon' },
    { id: 'Ozar', label: 'Ozar' },
    { id: 'Phaltan', label: 'Phaltan' },
    { id: 'Yevla', label: 'Yevla' },
    { id: 'Shahade', label: 'Shahade' },
    { id: 'Vita', label: 'Vita' },
    { id: 'Umarkhed', label: 'Umarkhed' },
    { id: 'Warora', label: 'Warora' },
    { id: 'Pachora', label: 'Pachora' },
    { id: 'Tumsar', label: 'Tumsar' },
    { id: 'Manjlegaon', label: 'Manjlegaon' },
    { id: 'Sillod', label: 'Sillod' },
    { id: 'Arvi', label: 'Arvi' },
    { id: 'Nandura', label: 'Nandura' },
    { id: 'Vaijapur', label: 'Vaijapur' },
    { id: 'Wadgaon Road', label: 'Wadgaon Road' },
    { id: 'Sailu', label: 'Sailu' },
    { id: 'Murtijapur', label: 'Murtijapur' },
    { id: 'Tasgaon', label: 'Tasgaon' },
    { id: 'Mehkar', label: 'Mehkar' },
    { id: 'Yawal', label: 'Yawal' },
    { id: 'Pulgaon', label: 'Pulgaon' },
    { id: 'Nilanga', label: 'Nilanga' },
    { id: 'Wai', label: 'Wai' },
    { id: 'Umarga', label: 'Umarga' },
    { id: 'Paithan', label: 'Paithan' },
    { id: 'Rahuri', label: 'Rahuri' },
    { id: 'Nawapur', label: 'Nawapur' },
    { id: 'Tuljapur', label: 'Tuljapur' },
    { id: 'Morshi', label: 'Morshi' },
    { id: 'Purna', label: 'Purna' },
    { id: 'Satana', label: 'Satana' },
    { id: 'Pathri', label: 'Pathri' },
    { id: 'Sinnar', label: 'Sinnar' },
    { id: 'Uchgaon', label: 'Uchgaon' },
    { id: 'Uran', label: 'Uran' },
    { id: 'Pen', label: 'Pen' },
    { id: 'Karjat', label: 'Karjat' },
    { id: 'Manwath', label: 'Manwath' },
    { id: 'Partur', label: 'Partur' },
    { id: 'Sangole', label: 'Sangole' },
    { id: 'Mangrulpir', label: 'Mangrulpir' },
    { id: 'Risod', label: 'Risod' },
    { id: 'Shirur', label: 'Shirur' },
    { id: 'Savner', label: 'Savner' },
    { id: 'Sasvad', label: 'Sasvad' },
    { id: 'Pandharkaoda', label: 'Pandharkaoda' },
    { id: 'Talode', label: 'Talode' },
    { id: 'Shrigonda', label: 'Shrigonda' },
    { id: 'Shirdi', label: 'Shirdi' },
    { id: 'Raver', label: 'Raver' },
    { id: 'Mukhed', label: 'Mukhed' },
    { id: 'Rajura', label: 'Rajura' },
    { id: 'Vadgaon Kasba', label: 'Vadgaon Kasba' },
    { id: 'Tirora', label: 'Tirora' },
    { id: 'Mahad', label: 'Mahad' },
    { id: 'Lonar', label: 'Lonar' },
    { id: 'Sawantwadi', label: 'Sawantwadi' },
    { id: 'Pathardi', label: 'Pathardi' },
    { id: 'Pauni', label: 'Pauni' },
    { id: 'Ramtek', label: 'Ramtek' },
    { id: 'Mul', label: 'Mul' },
    { id: 'Soyagaon', label: 'Soyagaon' },
    { id: 'Mangalvedhe', label: 'Mangalvedhe' },
    { id: 'Narkhed', label: 'Narkhed' },
    { id: 'Shendurjana', label: 'Shendurjana' },
    { id: 'Patur', label: 'Patur' },
    { id: 'Mhaswad', label: 'Mhaswad' },
    { id: 'Loha', label: 'Loha' },
    { id: 'Nandgaon', label: 'Nandgaon' },
    { id: 'Warud', label: 'Warud' },
  ],
  Goa: [
    { id: 'Marmagao', label: 'Marmagao' },
    { id: 'Panaji', label: 'Panaji' },
    { id: 'Margao', label: 'Margao' },
    { id: 'Mapusa', label: 'Mapusa' },
  ],
  'West Bengal': [
    { id: 'Kolkata', label: 'Kolkata' },
    { id: 'Siliguri', label: 'Siliguri' },
    { id: 'Asansol', label: 'Asansol' },
    { id: 'Raghunathganj', label: 'Raghunathganj' },
    { id: 'Kharagpur', label: 'Kharagpur' },
    { id: 'Naihati', label: 'Naihati' },
    { id: 'English Bazar', label: 'English Bazar' },
    { id: 'Baharampur', label: 'Baharampur' },
    { id: 'Hugli-Chinsurah', label: 'Hugli-Chinsurah' },
    { id: 'Raiganj', label: 'Raiganj' },
    { id: 'Jalpaiguri', label: 'Jalpaiguri' },
    { id: 'Santipur', label: 'Santipur' },
    { id: 'Balurghat', label: 'Balurghat' },
    { id: 'Medinipur', label: 'Medinipur' },
    { id: 'Habra', label: 'Habra' },
    { id: 'Ranaghat', label: 'Ranaghat' },
    { id: 'Bankura', label: 'Bankura' },
    { id: 'Nabadwip', label: 'Nabadwip' },
    { id: 'Darjiling', label: 'Darjiling' },
    { id: 'Purulia', label: 'Purulia' },
    { id: 'Arambagh', label: 'Arambagh' },
    { id: 'Tamluk', label: 'Tamluk' },
    {
      id: 'AlipurdUrban Agglomerationr',
      label: 'AlipurdUrban Agglomerationr',
    },
    { id: 'Suri', label: 'Suri' },
    { id: 'Jhargram', label: 'Jhargram' },
    { id: 'Gangarampur', label: 'Gangarampur' },
    { id: 'Rampurhat', label: 'Rampurhat' },
    { id: 'Kalimpong', label: 'Kalimpong' },
    { id: 'Sainthia', label: 'Sainthia' },
    { id: 'Taki', label: 'Taki' },
    { id: 'Murshidabad', label: 'Murshidabad' },
    { id: 'Memari', label: 'Memari' },
    { id: 'Paschim Punropara', label: 'Paschim Punropara' },
    { id: 'Tarakeswar', label: 'Tarakeswar' },
    { id: 'Sonamukhi', label: 'Sonamukhi' },
    { id: 'PandUrban Agglomeration', label: 'PandUrban Agglomeration' },
    { id: 'Mainaguri', label: 'Mainaguri' },
    { id: 'Malda', label: 'Malda' },
    { id: 'Panchla', label: 'Panchla' },
    { id: 'Raghunathpur', label: 'Raghunathpur' },
    { id: 'Mathabhanga', label: 'Mathabhanga' },
    { id: 'Monoharpur', label: 'Monoharpur' },
    { id: 'Srirampore', label: 'Srirampore' },
    { id: 'Adra', label: 'Adra' },
  ],
};